<template>
  <div class="pc">
    <!-- 直播弹层 -->
    <transition name="fade">
      <Live v-show="liveShow" @liveClose="liveShow = false"></Live>
    </transition>
    <!-- 顶部logo -->
    <transition name="fade">
      <div class="pc_top" v-show="topShow">
        <div class="pc_top_logo">
          <img src="../assets/img/mobile_logo.png" alt="" />
        </div>
        <div class="pc_top_look">
          <img src="../assets/img/icon_look.png" alt="" />
          {{ 522580 + visitNum * 3 }}
        </div>
        <div class="pc_top_zhibo" @click="liveShow = true">
          <img src="../assets/img/mobile_zhibo.png" alt="" />
        </div>
      </div>
    </transition>
    <!-- 路线总揽 -->
    <transition name="fade">
      <RoadListTotal
        v-show="roadListTotalShow"
        :roadList="roadList"
        @clickItem="clickRoadListTotal"
      ></RoadListTotal>
    </transition>

    <!-- 底部工具栏 -->
    <transition name="fade">
      <div
        class="pc_tools"
        :class="{ 'pc_tools--bottom': curPano.id == mainEntityId }"
        v-show="toolsShow"
      >
        <div
          class="pc_tools_qrcode"
          v-show="shareShow && shareSelectedIndex === 0"
        >
          <canvas id="canvas" class="pc_share_weixin_qrcode">
            <!-- <canvas id="canvas"></canvas> -->
          </canvas>
          <!-- <p class="pc_share_weixin_tip">
          用微信“扫一扫”二维码，即可把链接<br />分享给您的微信好友或朋友圈
        </p> -->
        </div>
        <div class="pc_tools_share" v-show="shareShow">
          <div
            class="pc_tools_share_item pc_tools_share_item--weixin"
            :class="{
              'pc_tools_share_item--weixin--selected': shareSelectedIndex === 0,
            }"
            @click="shareClick(0)"
          ></div>
          <div
            class="pc_tools_share_item pc_tools_share_item--qq"
            :class="{
              'pc_tools_share_item--qq--selected': shareSelectedIndex === 1,
            }"
            @click="shareClick(1)"
          ></div>
          <div
            class="pc_tools_share_item pc_tools_share_item--weibo"
            :class="{
              'pc_tools_share_item--weibo--selected': shareSelectedIndex === 2,
            }"
            @click="shareClick(2)"
          ></div>
        </div>
        <div class="pc_tools_list">
          <div class="pc_tools_list_item">
            <img
              src="../assets/img/pc/tools_full.png"
              alt=""
              @click="setPageFullscreen"
              v-show="!isPageFullScreen"
            />
            <img
              src="../assets/img/pc/tools_full-true.png"
              alt=""
              @click="setPageFullscreen"
              v-show="isPageFullScreen"
            />
          </div>
          <div class="pc_tools_list_item">
            <img
              src="../assets/img/pc/tools_like.png"
              alt=""
              @click="addLike"
              v-show="!isLike"
            />
            <img
              src="../assets/img/pc/tools_like-true.png"
              alt=""
              v-show="isLike"
            />
            <!-- <div class="pc_tools_list_item_like">{{ likeNum }}</div> -->
            <div class="pc_tools_list_item_like" style="margin-left: 2px">
              999+
            </div>
          </div>
          <div class="pc_tools_list_item">
            <img
              src="../assets/img/pc/tools_share.png"
              alt=""
              v-show="!shareShow"
              @click="shareShow = !shareShow"
            />
            <img
              src="../assets/img/pc/tools_share-true.png"
              alt=""
              v-show="shareShow"
              @click="shareShow = !shareShow"
            />
          </div>
          <div class="pc_tools_list_item">
            <img
              v-show="!isAudioPlay"
              src="../assets/img/pc/tools_music.png"
              alt=""
              @click="audioPlay"
            />
            <img
              v-show="isAudioPlay"
              src="../assets/img/pc/tools_music-true.png"
              alt=""
              @click="audioPause"
            />
          </div>
        </div>
        <div class="pc_tools_dark" v-show="curPano.id === mainEntityId">
          <img
            src="../assets/img/pc/tools_dark.png"
            alt=""
            v-show="!isDark"
            @click="darkOn"
          />
          <img
            src="../assets/img/pc/tools_dark-true.png"
            alt=""
            v-show="isDark"
            @click="darkOff"
          />
        </div>
      </div>
    </transition>
    <!-- 右上角小地图 -->
    <transition name="fade">
      <div class="map-box" v-show="mapShow">
        <div class="back"></div>
        <div class="map">
          <div id="mapContainer"></div>
          <div ref="box" class="radar" v-show="false"></div>
          <div class="circle"></div>
        </div>
        <div class="click-cover" @click="showMap()"></div>
      </div>
    </transition>
    <!-- 全屏地图 -->
    <transition name="fade">
      <div class="mobile_map" v-show="mapFullscreen">
        <div class="mobile_map_close" @click="mapFullscreen = false">
          <img src="../assets/img/video_close.png" alt="" />
        </div>
        <div class="full-map-box">
          <div id="fullMapContainer"></div>
          <div
            @click="fullMapListShow = !fullMapListShow"
            class="mobile_map_list_title"
            :class="{ 'mobile_map_list_title--show': fullMapListShow }"
          >
            <img src="../assets/img/icon_open.png" alt="" />
            地点列表
          </div>
          <div
            class="mobile_map_list"
            :class="{ 'mobile_map_list--show': fullMapListShow }"
          >
            <p
              @click="selectMapMarker(item)"
              class="mobile_map_list_item"
              :class="{
                'mobile_map_list_item--selected': item === mapSelected,
              }"
              v-for="(item, index) in mapList"
              :key="index"
            >
              {{ allPano[item].name }}
            </p>
          </div>
        </div>
      </div>
    </transition>
    <!-- 返回键 -->
    <div class="pc_back" v-show="backShow" @click="clickBack">
      <img src="../assets/img/pc/return.png" alt="" />
    </div>
    <!-- tab切换 -->
    <transition name="fade">
      <div
        class="pc_tab"
        :class="{ 'pc_tab--close': !tabOpen }"
        v-show="tabShow"
      >
        <div class="pc_tab_link" @click="tabOpen = !tabOpen">
          <img
            v-show="tabOpen"
            src="../assets/img/pc/tab_link-close.png"
            alt=""
          />
          <img
            v-show="!tabOpen"
            src="../assets/img/pc/tab_link-open.png"
            alt=""
          />
        </div>
        <div class="pc_tab_item pc_tab_item--yanxue" @click="tabClick(0)">
          <div class="pc_tab_item_icon"></div>
          <div class="pc_tab_item_title">研学</div>
        </div>
        <div class="pc_tab_item pc_tab_item--zixun" @click="tabClick(1)">
          <div class="pc_tab_item_icon"></div>
          <div class="pc_tab_item_title">资讯</div>
        </div>
        <div class="pc_tab_item pc_tab_item--zhoubian" @click="tabClick(2)">
          <div class="pc_tab_item_icon"></div>
          <div class="pc_tab_item_title">周边</div>
        </div>
        <div class="pc_tab_item pc_tab_item--yinji" @click="tabClick(3)">
          <div class="pc_tab_item_icon"></div>
          <div class="pc_tab_item_title">红色印记</div>
        </div>
      </div>
    </transition>
    <!-- 研学 -->
    <transition name="fade">
      <div class="pc_yanxue" v-show="yanxueShow">
        <div class="pc_yanxue_return" @click="yanxueShow = false">
          <img src="../assets/img/pc/return.png" alt="" />
        </div>
        <div class="pc_yanxue_left">
          <img v-if="moudleMap" src="../assets/img/pc/yanxue_left.png" alt="" />
          <img
            v-if="!moudleMap"
            src="../assets/img/pc/yanxue_left-road.png"
            alt=""
          />
        </div>
        <div class="pc_yanxue_right">
          <div class="pc_yanxue_right_title">
            <img src="../assets/img/pc/title.png" alt="" />
          </div>
          <div class="pc_yanxue_right_detail">
            {{ appInfo.description }}
          </div>
          <div class="pc_yanxue_right_list">
            <div
              class="pc_yanxue_right_list_item"
              v-for="(item, index) in roadList"
              :key="index"
              @click="clickYanxueSlide(index)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- 手绘地图 -->
    <transition name="fade">
      <RoadList
        v-show="roadListShow"
        :roadList="roadList"
        :roadListIndex="roadListIndex"
        :tipsShow="tipsShow"
        @setPano="roadSetPano"
        :moudleMap="moudleMap"
      ></RoadList>
    </transition>
    <!-- 全景相册 -->
    <transition name="fade">
      <swiper
        v-if="panoListShow"
        :options="panoListSwiperOptions"
        class="pc_panolist"
      >
        <swiper-slide
          class="pc_panolist_item"
          :class="{ 'pc_panolist_item--selected': index === panoListIndex }"
          v-for="(item, index) in curPano.panoArray"
          :key="index"
        >
          <img :src="item.thumbnail" alt="" />
          <div
            class="pc_panolist_item_cover"
            v-show="index !== panoListIndex"
            @click="clickPanoList(item)"
          >
            <!-- <p>{{ curPano.name }}</p> -->
          </div>
        </swiper-slide>
      </swiper>
    </transition>
    <!-- 全景详情 -->
    <transition name="fade">
      <div class="pc_panodetail" v-show="panoListShow">
        <img
          class="pc_panodetail_icon"
          src="../assets/img/pc/icon_audio-black.png"
          v-show="entityAudioIsPlay"
          @click="entityAudioPause()"
          alt=""
        />
        <img
          class="pc_panodetail_icon"
          src="../assets/img/pc/icon_audio-black.png"
          v-show="!entityAudioIsPlay"
          @click="entityAudioPlay()"
          alt=""
        />
        <div class="pc_panodetail_pic">
          <img :src="curPano.thumbnail" alt="" />
        </div>
        <div class="pc_panodetail_title">{{ curPano.name }}</div>
        <div class="pc_panodetail_text">{{ curPano.description }}</div>
      </div>
    </transition>
    <!-- 图文形式的地点介绍 -->
    <transition name="fade">
      <div class="pc_infodetail" v-show="infoDetailShow">
        <div class="pc_infodetail_content">
          <div class="pc_infodetail_content_close" @click="infoDetailReturn">
            <img src="../assets/img/pc/close.png" alt="" />
          </div>
          <div class="pc_infodetail_content_left">
            <swiper
              class="pc_infodetail_content_left_swiper"
              :options="infoDetailSwiperOptions"
            >
              <swiper-slide
                v-for="(item, index) in curPano.plans"
                :key="index"
                class="pc_infodetail_content_left_swiper_slide"
              >
                <img :src="item.planUrl" alt=""
              /></swiper-slide>
              <div class="infodetail_swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
          <div class="pc_infodetail_content_right">
            <img
              class="pc_infodetail_content_right_icon"
              src="../assets/img/pc/icon_audio.png"
              v-show="entityAudioIsPlay"
              @click="entityAudioPause()"
              alt=""
            />
            <img
              class="pc_infodetail_content_right_icon"
              src="../assets/img/pc/icon_audio.png"
              v-show="!entityAudioIsPlay"
              @click="entityAudioPlay()"
              alt=""
            />
            <div class="pc_infodetail_content_right_title">
              {{ curPano.name }}
            </div>
            <div class="pc_infodetail_content_right_text">
              {{ curPano.description }}
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- 资讯 -->
    <transition name="fade">
      <Article
        :articleList="articleList"
        @return="articleReturn"
        v-show="tabIndex === 1"
      ></Article>
    </transition>

    <!-- 周边 -->
    <transition name="fade">
      <Around
        :aroundList="aroundList"
        @return="aroundReturn"
        v-show="tabIndex === 2 && aroundListShow"
        @setPano="aroundSetPano"
      ></Around>
    </transition>
    <!-- 红色印记 -->
    <transition name="fade">
      <Video
        :videoList="videoList"
        @return="videoReturn"
        v-if="tabIndex === 3"
      ></Video>
    </transition>
    <!-- 视频播放组件 -->
    <transition name="fade">
      <VideoPlay
        v-show="videoPlayShow"
        :videoSrc="videoPlaySrc"
        @close="videoPalyClose"
      ></VideoPlay>
    </transition>
    <!-- 实景音频 -->
    <audio
      id="entityAudioDom"
      preload="auto"
      loop="loop"
      :src="curPano.audioIntro"
    ></audio>
    <!-- 欢迎页面 -->
    <transition name="fade">
      <WelPage v-if="welPageShow" @welEnter="welEnter"></WelPage>
    </transition>
  </div>
</template>
<script>
import Around from './components/Around'
import Article from './components/Article'
import Video from './components/Video.vue'
import Live from './components/Live'
import VideoPlay from './components/VideoPlay.vue'
import RoadList from './components/RoadList.vue'
import WelPage from './components/WelPage.vue'
import RoadListTotal from './components/RoadListTotal.vue'
export default {
  components: {
    Around,
    Article,
    Video,
    Live,
    VideoPlay,
    RoadList,
    WelPage,
    RoadListTotal,
  },
  data() {
    return {
      shareShow: false, // 是否展示分享
      shareSelectedIndex: 0, //分享类型index
      isPageFullScreen: false, //是否全屏
      visitNum: 0, //浏览数
      likeNum: 0, // 点赞数
      isLike: false, // 是否点赞
      isAudioPlay: false, // 是否播放背景音乐
      isDark: false, // 是否是夜间模式
      hasDark: true, // 是否存在夜间模式
      darkPanoInfo: {}, //夜间模式的panoid
      topShow: true, //顶部标题展示
      toolsShow: true, //右侧工具展示
      loadingShow: true, // 加载页面
      mapShow: true, // 右上角小地图
      welPageShow: true, // 欢迎页面
      mapList: [], // 地图列表
      mapFullscreen: false, // 全屏地图展示
      mapSelected: '', // 地图中选中的id
      fullMapListShow: false, // 全屏地图里面的文字列表
      mapPanoFlag: false, // 标记观看入口，true代表从小地图进入
      backShow: false,
      APPID: '2106121911',
      appList: {},
      appInfo: {},
      allPano: {},
      roadList: [
        // {
        //   name: '',
        //   entityId: '',
        //   description: '',
        //   mapPic: '',
        //   mapMarker: [],
        //   thumbnail: '',
        // },
      ],
      roadListIndex: 0,
      roadListShow: false,
      panoListIndex: 0,
      panoListShow: false,
      panoDetailShow: false,
      infoDetailShow: false,
      articleList: [],
      aroundList: [],
      aroundListShow: true,
      videoList: [],
      entityAudioIsPlay: false, // pano音频
      mainEntityId: '', // 主全景地点id，用于返回逻辑
      curPano: {
        id: '',
        level: 1,
        name: '',
        panoArray: [],
        markerInfo: {},
      },
      markerArray: [],
      liveShow: false,
      videoPlayShow: false,
      videoPlaySrc: '',
      tabShow: true,
      tabOpen: true,
      tabIndex: 0,
      yanxueShow: false,
      panoListSwiperOptions: {
        slidesPerView: 'auto',
      },
      infoDetailSwiperOptions: {
        pagination: {
          el: '.infodetail_swiper-pagination',
        },
      },
      roadListTotalShow: true,
      tipsShow: false,
      moudleMap: true,
      moudleMapData: [
        {
          mapPic: require('../assets/img/roadlist_map1.png'),
          mapMarker: [
            {
              abscissa: '75%',
              ordinate: '85%',
            },
            {
              abscissa: '50%',
              ordinate: '78%',
            },
            {
              abscissa: '31.2%',
              ordinate: '69.4%',
            },
            {
              abscissa: '18.75%',
              ordinate: '61.1%',
            },
            {
              abscissa: '15%',
              ordinate: '51.1%',
            },
            {
              abscissa: '66.25%',
              ordinate: '41.32%',
            },
            {
              abscissa: '68.75%',
              ordinate: '32%',
            },
            {
              abscissa: '62.5%',
              ordinate: '22.64%',
            },
          ],
        },
        {
          mapPic: require('../assets/img/roadlist_map2.png'),
          mapMarker: [
            {
              abscissa: '75.6%',
              ordinate: '86.22%',
            },
            {
              abscissa: '44%',
              ordinate: '76%',
            },
            {
              abscissa: '22.5%',
              ordinate: '64.52%',
            },
            {
              abscissa: '13.12%',
              ordinate: '52%',
            },
            {
              abscissa: '75.6%',
              ordinate: '39.81%',
            },
            {
              abscissa: '48.1%',
              ordinate: '30.9%',
            },
          ],
        },
        {
          mapPic: require('../assets/img/roadlist_map3.png'),
          mapMarker: [
            {
              abscissa: '75.3%',
              ordinate: '86%',
            },
            {
              abscissa: '40%',
              ordinate: '74.1%',
            },
            {
              abscissa: '14.68%',
              ordinate: '56%',
            },
            {
              abscissa: '51.5%',
              ordinate: '42.26%',
            },
            {
              abscissa: '43.75%',
              ordinate: '30.1%',
            },
          ],
        },
        {
          mapPic: require('../assets/img/roadlist_map4.png'),
          mapMarker: [
            {
              abscissa: '74.68%',
              ordinate: '85.84%',
            },
            {
              abscissa: '35.31%',
              ordinate: '71.88%',
            },
            {
              abscissa: '16.25%',
              ordinate: '57.92%',
            },
            {
              abscissa: '28.43%',
              ordinate: '44.15%',
            },
            {
              abscissa: '62.18%',
              ordinate: '30.75%',
            },
          ],
        },
        {
          mapPic: require('../assets/img/roadlist_map5.png'),
          mapMarker: [
            {
              abscissa: '75.62%',
              ordinate: '85.66%',
            },
            {
              abscissa: '51.87%',
              ordinate: '79.62%',
            },
            {
              abscissa: '33.12%',
              ordinate: '70%',
            },
            {
              abscissa: '18.75%',
              ordinate: '60%',
            },
            {
              abscissa: '15.62%',
              ordinate: '50.94%',
            },
            {
              abscissa: '71.25%',
              ordinate: '40.37%',
            },
            {
              abscissa: '46.87%',
              ordinate: '26.41%',
            },
          ],
        },
        {
          mapPic: require('../assets/img/roadlist_map6.png'),
          mapMarker: [
            {
              abscissa: '74.37%',
              ordinate: '85.66%',
            },
            {
              abscissa: '25%',
              ordinate: '66%',
            },
            {
              abscissa: '16.25%',
              ordinate: '49.2%',
            },
            {
              abscissa: '65.62%',
              ordinate: '31.32%',
            },
          ],
        },
      ],
    }
  },
  mounted() {
    // 新华网参数 ?appid=2109002708&map=false
    // 根据链接参数获取appid
    if (this.util.getUrlParam('appid')) {
      this.APPID = this.util.getUrlParam('appid')
    }
    // 根据链接参数判断是否切换非手绘地图模式
    if (this.util.getUrlParam('map') === 'false') {
      this.moudleMap = false
    }
    if (this.util.isMobile()) {
      let url = location.href
      let url1 = url.replace('index.html', 'mobile.html')
      location.href = url1
      return false
    }
    // 生成二维码
    window.QRCode.toCanvas(document.getElementById('canvas'), location.href, {
      // width: 100,
    })
    window.mapMarkerArray = []
    this.markerArray = []
    this.axios
      .all([this.$api.getAppList(this.APPID), this.$api.getAppInfo(this.APPID)])
      .then(
        this.axios.spread((appList, appInfo) => {
          this.appList = appList.data.data
          this.appInfo = appInfo.data.data
          // 设置背景音乐
          const audioUrl = appInfo.data.data.bgAudioUrl
          document.getElementById('audioDom').src = audioUrl
          // console.log(this.appList)
          this.formatData()
          this.formatRoadList()
          this.formatArticleList()
          this.formatAroundList()
          this.formatVedioList()
          this.initEngine()
          this.initMap()
          this.addMapMarker()
          this.util.setWechartTitle(this.appInfo.name)
          this.setShare()
          this.util.addStatistics(this.appInfo.statId, this.appInfo.statCid)
          // setTimeout(() => {
          //   this.roadListShow = false
          // }, 1500)
          // setTimeout(() => {
          //   this.loadingShow = false
          // }, 2000)
        })
      )
    this.getLikeAndVisit()
    this.addVisit()
    this.couldLike()
  },
  methods: {
    clickRoadListTotal(index) {
      this.roadListIndex = Number(index)
      this.roadListShow = true
      if (this.moudleMap) {
        this.tipsShow = true
        setTimeout(() => {
          this.tipsShow = false
        }, 8000)
      }
    },
    videoPalyClose() {
      this.videoPlaySrc = ''
      this.videoPlayShow = false
      window.pano.setAutoPlayEnable(true)
    },
    welEnter() {
      this.welPageShow = false
      this.audioPlay()
    },
    setShare() {
      let shareUrl = null
      let shareTitle = this.appInfo.shareTitle || this.appInfo.name
      let shareDesc = this.appInfo.shareDesc
      let shareImg = this.util.checkImageUrl(this.appInfo.thumbnail)
      window.getShareInfoSub(shareUrl, shareTitle, shareDesc, shareImg)
    },
    // 初始化地图
    initMap() {
      // 左上角小地图
      window.miniMap = new window.AMap.Map('mapContainer', {
        zoom: 12,
        zoomEnable: false,
        dragEnable: false,
      })
      // 全屏地图
      window.fullMap = new window.AMap.Map('fullMapContainer', {
        zoom: 13,
      })
      let southWest = new window.AMap.LngLat(-180, -90)
      let northEast = new window.AMap.LngLat(180, 90)
      let bounds = new window.AMap.Bounds(southWest, northEast)
      window.fullMap.setBounds(bounds)
      let rectangle = new window.AMap.Rectangle({
        bounds: bounds, // 圆心位置
        strokeOpacity: 0,
        fillColor: '#041420', // 填充颜色
        fillOpacity: 0.3, // 填充透明度
      })
      window.fullMap.add(rectangle)
      // 销毁地图，并清空地图容器
      // map.destroy()
    },
    // 显示全屏地图
    showMap() {
      // this.util.panoInter(false)
      // this.interfaceShow = false
      this.mapFullscreen = true
      window.fullMap.setCenter(this.curPano.lnglat)
      this.mapSelected = this.curPano.id
      this.addMapMarker()
      window.fullMap.setZoom(15)
    },
    // 设置地图中心点
    setMapCenter(lnglat) {
      window.miniMap.setCenter(lnglat)
    },
    // 添加地图中marker
    addMapMarker() {
      if (window.mapMarkerArray.length > 0) {
        window.mapMarkerArray.forEach((mk, idx) => {
          window.fullMap.remove(mk)
        })
      }
      window.mapMarkerArray = []
      this.mapList.forEach((el, i) => {
        // console.log(this.allPano[el], 'mapmarkerlist')
        if (this.allPano[el].lnglat.length === 2) {
          let thumbnail = this.allPano[el].thumbnail
          let name = this.allPano[el].name
          // let mapMarkerType = this.allPano[el].mapMarkerType || 'chanyefazhan'
          let isSelected = el === this.mapSelected ? 'selected' : ''
          let zIndex = el === this.mapSelected ? 102 : 101
          let content = ''
          content = `
            <div class="map-marker ${isSelected}">
              <p>${name}</p>
              <img src="${this.util.getPicUrl(thumbnail, 'imgsmall')}"/>
            </div>
          `
          let marker = new window.AMap.Marker({
            zIndex: zIndex,
            content: content, // 自定义点标记覆盖物内容
            position: this.allPano[el].lnglat, // 基点位置
            offset: new window.AMap.Pixel(-20, -40), // 相对于基点的偏移位置
          })

          window.mapMarkerArray.push(marker)
          window.fullMap.add(marker)
          marker.on('click', () => {
            this.selectMapMarker(el)
          })
          marker.on('mouseover', () => {
            marker.setzIndex(103)
          })
          marker.on('mouseout', () => {
            marker.setzIndex(101)
          })
        }
      })
    },
    selectMapMarker(id) {
      if (this.mapSelected === id) {
        this.mapFullscreen = false
        this.mapPanoFlag = true
        // 判断是全景还是图文形式
        if (this.allPano[id].tags && this.allPano[id].tags[0] === 'image') {
          //图文形式
          // console.log('imge xingshi ')
          this.curPano = this.allPano[id]
          this.infoDetailShow = true
        } else {
          // 全景形式
          this.setPano(id)
          this.tabShow = false
          this.topShow = false
          this.bottomShow = false
          this.panoListShow = true
          this.backShow = true
          this.roadListTotalShow = false
        }
        setTimeout(() => {
          this.entityAudioPlay()
          this.audioPause()
        }, 500)
      } else {
        this.selectedMapList(id)
      }
    },
    // 地图列表选择
    selectedMapList(id) {
      this.mapSelected = id
      window.fullMap.setCenter(this.allPano[id].lnglat)
      this.addMapMarker()
    },
    // 设置小地图方向
    setMiniMapRotate(deg) {
      window.pano.onHeadingChangeCallback = (heading) => {
        heading = window.pano.getHeading()
        heading = heading % 360
        if (heading < 0) {
          heading += 360
        }
        this.$refs.box.style.transform =
          'rotateZ(' + (heading - 90 - deg) + 'deg)'
      }
    },
    infoDetailReturn() {
      if (this.curPano.id !== this.mainEntityId) {
        this.tabShow = true
        this.topShow = true
        this.bottomShow = true
        this.panoListShow = false
        this.backShow = false
        this.setPano(this.mainEntityId)
      }
      this.infoDetailShow = false
      this.entityAudioPause()
    },
    clickBack() {
      if (this.mapPanoFlag) {
        // 从地图导览中进入
        this.tabIndex = 0
        this.mapPanoFlag = false
      } else {
        // 正常浏览轨迹
        console.log(this.tabIndex, 'index----')
        if (this.tabIndex === 0) {
          this.roadListShow = true
          setTimeout(() => {
            this.yanxueShow = true
          }, 500)
        }
        if (this.tabIndex === 2) {
          this.aroundListShow = true
        }
      }

      this.tabShow = true
      this.topShow = true
      this.bottomShow = true
      this.panoListShow = false
      this.backShow = false
      this.roadListTotalShow = true
      this.entityAudioPause()
      this.setPano(this.mainEntityId)
    },
    tabClick(index) {
      this.tabIndex = index
      if (index === 0) {
        // 点击研学
        this.yanxueShow = true
      } else if (index === 3) {
        // 点击印记
        this.audioPause()
      }
    },
    clickYanxueShow(value) {
      this.yanxueShow = value
    },
    yanxueSwiperChange() {
      this.roadListIndex = this.yanxueSwiper.realIndex
    },
    clickYanxueSlide(index) {
      this.roadListIndex = index
      this.roadListShow = true
      if (this.moudleMap) {
        this.tipsShow = true
        setTimeout(() => {
          this.tipsShow = false
        }, 8000)
      }
    },
    audioPlay() {
      let audioDom = document.getElementById('audioDom')
      audioDom.play()
      this.isAudioPlay = true
    },
    audioPause() {
      let audioDom = document.getElementById('audioDom')
      audioDom.pause()
      this.isAudioPlay = false
    },
    entityAudioPlay() {
      let audioDom = document.getElementById('entityAudioDom')
      audioDom.play()
      this.entityAudioIsPlay = true
    },
    entityAudioPause() {
      let audioDom = document.getElementById('entityAudioDom')
      audioDom.pause()
      this.entityAudioIsPlay = false
    },
    roadSwiperChange(index) {
      this.roadListIndex = index
      // console.log('mobileSwiperChange', this.roadListIndex)
    },
    roadSetPano(value, index) {
      if (value) {
        // console.log('第几条线路', index)
        // console.log('第几条线路的entityId', value)
        // 根据线路index以及entityId，找到对应的地图marker点，进行样式标记
        this.roadList[index].mapMarker.forEach((element, index) => {
          console.log(element, 'element----------')
          if (element.entityId === value) {
            // console.log('找到对应的marker')
            element.read = true
            // console.log(element)
          }
        })
        // 判断是全景还是图文形式
        if (this.allPano[value].tags[0] === 'image') {
          //图文形式
          console.log('imge 形式 ')
          this.curPano = this.allPano[value]
          this.infoDetailShow = true
        } else {
          // 全景形式
          this.setPano(value)
          this.yanxueShow = false
          setTimeout(() => {
            this.roadListShow = false
          }, 10)
          this.tabShow = false
          this.topShow = false
          this.bottomShow = false
          this.panoListShow = true
          this.backShow = true
          this.roadListTotalShow = false
        }

        setTimeout(() => {
          this.entityAudioPlay()
          this.audioPause()
        }, 500)
      } else {
        this.roadListShow = false
      }
    },
    videoReturn() {
      this.tabIndex = 0
    },
    articleReturn() {
      this.tabIndex = 0
      console.log(this.tabIndex)
    },
    aroundReturn() {
      this.tabIndex = 0
    },
    aroundSetPano(id) {
      this.setPano(id)
      // setTimeout(() => {
      //   this.entityAudioPlay()
      //   this.audioPause()
      // }, 500)
      this.yanxueShow = false
      this.tabShow = false
      this.topShow = false
      this.bottomShow = false
      this.backShow = true
      this.panoListShow = true
      this.roadListTotalShow = false
      setTimeout(() => {
        this.aroundListShow = false
      }, 100)
    },
    setPano(id, panoId) {
      this.panoListIndex = 0
      let isChange = false // 是否切换当前的curPano
      if (id) {
        if (this.curPano.id !== id) {
          this.curPano = this.allPano[id]
          isChange = true
          // this.setMiniMapRotate(
          //   this.curPano.panoInfo.heading ? this.curPano.panoInfo.heading : 0
          // )
          this.setMapCenter(this.curPano.lnglat)
          // 关闭夜景
          this.isDark = false
        }
      }
      if (panoId) {
        // console.log(panoId)
        this.curPano.panoArray.forEach((el, i) => {
          if (el.panoId === panoId) {
            this.panoListIndex = i
          }
        })
      }
      if (this.curPano.panoArray && this.curPano.panoArray.length > 0) {
        console.log('setPano-----切换图片')
        console.log(this.curPano.panoArray[this.panoListIndex])
        this.curPano.panoArray[this.panoListIndex].isView = true
        this.util.setPano(
          this.curPano.panoArray[this.panoListIndex],
          this.addMarker(this.curPano.id, this.panoListIndex)
        )
        if (isChange && this.curPano.id !== this.mainEntityId) {
          // 在全景内部切换下一个景点时，自动播放音频
          setTimeout(() => {
            this.entityAudioPlay()
          }, 500)
        }
      }
    },
    clickPanoList(item) {
      // console.log(item)
      this.setPano('', item.panoId)
    },
    formatData() {
      this.mainEntityId = this.appList.appGroupArray[0].appEntityArray[0].id
      this.appList.appGroupArray.forEach((appGroupEle, appGroupIdx) => {
        // console.log(appGroupEle.name)
        if (
          appGroupEle.name === '首页' ||
          appGroupEle.name === '研学' ||
          appGroupEle.name === '周边'
        ) {
          appGroupEle.appEntityArray.forEach((appEntityEle, appEntityIdx) => {
            if (appGroupEle.name === '周边') {
              this.mapList.push(appEntityEle.id)
            }
            this.allPano[appEntityEle.id] = this.util.initData(appEntityEle, 1)
            this.allPano[appEntityEle.id]['markerInfo'] = null
            this.allPano[appEntityEle.id]['description'] =
              appEntityEle.description
            this.allPano[appEntityEle.id]['audioIntro'] =
              appEntityEle.audioIntro
            this.allPano[appEntityEle.id]['plans'] = appEntityEle.plans
            this.allPano[appEntityEle.id]['tags'] = appEntityEle.tags
            appEntityEle.groupArray.forEach((groupEle, groupIdx) => {
              groupEle.materialArray.forEach((materialEle, materialIdx) => {
                if (materialEle.type === 'entity') {
                  if (appGroupEle.name === '研学') {
                    this.mapList.push(materialEle.id)
                  }
                  this.allPano[materialEle.id] = this.util.initData(
                    materialEle,
                    2
                  )
                  this.allPano[materialEle.id]['tags'] = materialEle.tags
                  this.allPano[materialEle.id]['plans'] = materialEle.plans
                  this.allPano[materialEle.id]['description'] =
                    materialEle.description
                  this.allPano[materialEle.id]['audioIntro'] =
                    materialEle.audioIntro
                  this.allPano[materialEle.id]['checked'] = false
                  this.allPano[materialEle.id]['child'] = []
                  this.allPano[materialEle.id]['markerInfo'] = null
                  // this.allPano[materialEle.id]['mapMarkerType'] =
                  // this.groupPlugins[groupEle.name].markerImage
                  // this.mapGroup.push(materialEle.id)
                  materialEle.facilityGroupArray.forEach(
                    (facilityGroupEle, facilityGroupIdx) => {
                      facilityGroupEle.facilityArray.forEach(
                        (facilityEle, facilityIdx) => {
                          this.allPano[facilityEle.id] = this.util.initData(
                            facilityEle,
                            3
                          )
                          this.allPano[facilityEle.id]['tags'] =
                            facilityEle.tags
                          this.allPano[facilityEle.id]['plans'] =
                            facilityEle.plans
                          this.allPano[facilityEle.id]['audioIntro'] =
                            facilityEle.audioIntro
                          this.allPano[facilityEle.id]['description'] =
                            facilityEle.description
                          this.allPano[facilityEle.id]['checked'] = false
                          this.allPano[facilityEle.id]['parent'] =
                            materialEle.id // 父级id
                          this.allPano[facilityEle.id]['markerInfo'] = null
                          this.allPano[materialEle.id]['child'].push(
                            facilityEle.id
                          )
                          // 地图marker
                          // if (facilityEle.extName) {
                          //   this.allPano[facilityEle.id]['lnglat'] =
                          //     facilityEle.extName.split(',')
                          // } else {
                          //   this.allPano[facilityEle.id]['lnglat'] = []
                          // }
                          // this.mapAllList.push(facilityEle.id)
                        }
                      )
                    }
                  )
                } else if (materialEle.type === 'facility') {
                  this.allPano[materialEle.id] = this.util.initData(
                    materialEle,
                    2
                  )
                }
              })
            })
          })
        }
      })
      this.curPano = this.allPano[this.mainEntityId]
    },
    initEngine() {
      /* eslint-disable-next-line */
      window.pano = new window.vizengine.PanoView(
        document.querySelector('#appContainer')
      )
      window.pano.onHeadingChangeCallback = (heading) => {
        // console.log('heading')
        if (this.curPano.markerInfo) {
          // console.log(1)
          if (
            this.curPano.markerInfo.panoArea &&
            this.curPano.markerInfo.panoArea.left !== '' &&
            this.curPano.markerInfo.panoArea.right !== ''
          ) {
            let left = this.curPano.markerInfo.panoArea.left
            let right = this.curPano.markerInfo.panoArea.right
            // console.log(left, 'left')
            // console.log(right, 'right')
            if (left > right) {
              right += 360
            }
            if (heading <= left) {
              window.pano.heading = left
            }
            if (heading >= right) {
              window.pano.heading = right
            }
          }
        }
      }
      window.pano.onPitchChangeCallback = (pitch) => {
        // console.log('pitch')
        if (this.curPano.markerInfo) {
          if (
            this.curPano.markerInfo.panoArea &&
            this.curPano.markerInfo.panoArea.top !== '' &&
            this.curPano.markerInfo.panoArea.bottom !== ''
          ) {
            let top = this.curPano.markerInfo.panoArea.top
            let bottom = this.curPano.markerInfo.panoArea.bottom
            // console.log(top, 'top')
            // console.log(bottom, 'bottom')
            if (top > 270) {
              top -= 360
            }
            if (bottom > 270) {
              bottom -= 360
            }
            if (pitch <= top) {
              window.pano.pitch = top
            }
            if (pitch >= bottom) {
              window.pano.pitch = bottom
            }
          }
        }
      }
      // console.log(this.curPano, 'this.curPano')
      window.pano.setPanoId(this.curPano.panoInfo.panoId, () => {
        window.pano.setHeading(this.curPano.panoInfo.heading || 0)
        window.pano.setPitch(this.curPano.panoInfo.pitch || 0)
        this.addMarker(this.mainEntityId, 0)
        this.setMapCenter(this.allPano[this.mainEntityId].lnglat)
        // this.setMiniMapRotate(
        //   this.curPano.panoInfo.heading ? this.curPano.panoInfo.heading : 0
        // )

        // this.util.panoInter(false)
        // window.pano.setHeading(0)
        // window.pano.setPitch(90)
        // window.pano.setPanoEffect(window.vizengine.PanoPlanet)
        // let rotateTween = new window.TWEEN.Tween(
        //   { heading: 0 },
        //   window.pano.tweenGroup
        // )
        //   .to(
        //     {
        //       heading: 180,
        //     },
        //     2000
        //   )
        //   .onStart(() => {
        //     window.pano.requestDraw()
        //   })
        //   .onUpdate((obj) => {
        //     window.pano.setHeading(obj.heading)
        //     window.pano.requestDraw()
        //   })
        //   .onComplete(() => {
        //     this.mainCoverShow = true
        //   })
        // let scaleTween = new window.TWEEN.Tween(
        //   { fov: 168 },
        //   window.pano.tweenGroup
        // )
        //   .to({ fov: 120 }, 2000)
        //   .onStart(() => {
        //     window.pano.requestDraw()
        //   })
        //   .onUpdate((obj) => {
        //     window.pano.camera.fov = obj.fov
        //     window.pano.requestDraw()
        //   })
        //   .easing(window.TWEEN.Easing.Quadratic.In)
        //   .start()
        // window.spinTween = new window.TWEEN.Tween(
        //   { heading: window.pano.getHeading() - 180 },
        //   window.pano.tweenGroup
        // )
        //   .to({ heading: window.pano.getHeading() - 160 }, 6000)
        //   .onUpdate((obj) => {
        //     window.pano.setHeading(obj.heading)
        //   })
        //   .onComplete(() => {
        //     // this.panoEnter()
        //   })
        // rotateTween.chain(window.spinTween)
        // rotateTween.start()
        // scaleTween.start()
        // document.getElementById('loadingProgress').style.width = '100%'
        // setTimeout(() => {
        //   document.getElementById('loading').style.opacity = 0
        //   setTimeout(() => {
        //     document.getElementById('loading').remove()
        //   }, 1500)
        // })
      })
      // this.util.addMtah5ClickStat(
      //   this.APPID,
      //   'pano-' + this.mainPanoInfo.panoId,
      //   this.$api
      // )
      window.pano.setAutoPlayEnable(true)
      window.pano.setOnClick(() => {
        // this.isShowShare = false
        // this.interfaceShow = !this.interfaceShow
        // this.showMarker(this.interfaceShow)
        console.log('点击全景')
        // this.interfaceSwitch()
      })
    },
    interfaceSwitch() {
      if (this.curPano.id === this.mainEntityId) {
        //  在主界面
        if (!this.topShow && !this.mapShow) {
          // 关闭状态
          this.topShow = true
          this.mapShow = true
          this.toolsShow = true
          this.tabShow = true
          this.bottomShow = true
          this.markerArray.forEach((el) => {
            window.pano.addView(el)
          })
        } else {
          // 开启状态
          window.pano.clearMarkers()
          this.topShow = false
          this.mapShow = false
          this.toolsShow = false
          this.tabShow = false
          this.bottomShow = false
        }
      } else {
        // 在全景详情页面
        if (!this.panoListShow && !this.mapShow) {
          // 关闭状态
          this.backShow = true
          this.mapShow = true
          this.toolsShow = true
          this.panoListShow = true
          this.markerArray.forEach((el) => {
            window.pano.addView(el)
          })
        } else {
          // 开启状态
          window.pano.clearMarkers()
          this.backShow = false
          this.mapShow = false
          this.toolsShow = false
          this.panoListShow = false
        }
      }
    },
    addMarker(id, index) {
      console.log('addMarker')
      window.pano.clearMarkers()
      this.markerArray = []
      this.$api
        .getPanoMarker({
          facilityId: this.allPano[id].facilityId,
          materialId: this.allPano[id].panoArray[index].materialId,
        })
        .then((res) => {
          this.allPano[id].markerInfo = res.data.data
          let mks = this.allPano[id].markerInfo.marker
          // console.log(mks, 'mks')
          // 判断是否有日夜景切换
          if (res.data.data.switchMaterialArray.length > 0) {
            if (res.data.data.switchMaterialArray[0].effectTags !== '日景') {
              console.log(res.data.data.switchMaterialArray[0])
              this.hasDark = true
              this.darkPanoInfo = res.data.data.switchMaterialArray[0]
            }
          } else {
            this.hasDark = false
            this.darkPanoInfo = {}
          }
          for (var i = 0; i < mks.length; i++) {
            let element = mks[i]
            let marker = null
            marker = document.createElement('div') // 可以为任意dom元素
            marker.setAttribute('id', 'marker')
            // marker.markerType = 1 // 让vr模式下可以展示marker
            marker.style.position = 'relative'
            // marker.vrText = element.name // 必须设置才能展示vrmarker
            marker.anchorX = 0.5 // 设置锚点的横坐标(0-1,0表示最左，1表示最右)
            marker.anchorY = 1 // 设置锚点的纵坐标(0-1,0表示最上，1表示最下)
            marker.heading = element.heading // marker在全景中的正北方向的偏转角度
            marker.pitch = element.pitch // marker在全景中的俯仰角度
            if (element.type === 'pano') {
              if (element.properties.entityId) {
                if (this.allPano[element.properties.entityId]) {
                  // console.log(element, 'marker')
                  let id = element.properties.entityId
                  let panoId = element.properties.panoId
                  let thumbnail = ''
                  this.allPano[element.properties.entityId].panoArray.forEach(
                    (el, i) => {
                      if (el.panoId === panoId) {
                        thumbnail = el.thumbnail
                      }
                    }
                  )
                  marker.onclick = () => {
                    console.log('markerClick')
                    this.setPano(id, panoId)
                  }
                  if (element.style === 'marker-red') {
                    marker.innerHTML = `
                   <div class="marker marker--go">
                    <p>前往${element.name}</p>
                    <img src="${require('../assets/img/marker-go.png')}" alt="">
                   </div>
                   `
                  } else {
                    marker.innerHTML = `
                   <div class="marker">
                    <p>${element.name}</p>
                    <img src="${this.util.getPicUrl(
                      thumbnail,
                      'imgsmall'
                    )}" alt="">
                   </div>
                   `
                  }
                }
              }
            } else if (element.type === 'info') {
              // 图文marker，继续判断是首页的路线跳转或链接
              if (element.linkName === 'road') {
                // 首页路线
                marker.innerHTML = `
                   <div class="marker marker--road">
                    <p>${element.name}</p>
                   </div>
                   `
                marker.onclick = () => {
                  this.roadListIndex = Number(element.properties.content)
                  this.roadListShow = true
                  console.log('选择路线', this.roadListIndex)
                }
              } else if (element.linkName === 'href') {
                // 链接形式
                marker.innerHTML = `
                   <div class="marker marker--href">
                   </div>
                   `
                marker.onclick = () => {
                  window.open(element.properties.content, '_blank')
                }
              }
            } else if (element.type === 'video') {
              // 视频marker
              marker.innerHTML = `
                   <div class="marker marker--video">
                    <p>点击观看 红色故事</p>
                    <img src="${require('../assets/img/marker-video.png')}" alt="">
                   </div>
                   `
              marker.onclick = () => {
                this.videoPlaySrc = element.properties.url
                console.log(element.properties.url)
                this.videoPlayShow = true
                window.pano.setAutoPlayEnable(false)
                this.audioPause()
                this.entityAudioPause()
              }
            }
            window.pano.addMarker(marker)
            this.markerArray.push(marker)
          }
          // setSunOrMoon(res.data.data.switchMaterialArray)
          // tempFun(res.data.data.marker)
        })
    },
    formatRoadList() {
      this.appList.appGroupArray.forEach((appGroupEle, appGroupIdx) => {
        // console.log(appGroupEle.name)
        if (appGroupEle.name === '研学') {
          appGroupEle.appEntityArray.forEach((appEntityEle, appEntityIdx) => {
            // console.log(appEntityEle, 'appEntityEle')
            let obj = {
              name: appEntityEle.name,
              entityId: appEntityEle.id,
              description: appEntityEle.description,
              mapPic: '',
              mapMarker: [],
              thumbnail: appEntityEle.thumbnail,
            }
            this.roadList.push(obj)
          })
          // console.log(this.roadList)
        }
      })
      //  拼装所有entityInfo请求的方法
      const handleItem = (value) => {
        return this.$api.getEntityInfo(value)
      }
      const axiosArr = []
      for (let index = 0; index < this.roadList.length; index++) {
        const element = this.roadList[index]
        // console.log(element)
        axiosArr.push(handleItem(element.entityId))
      }
      this.axios.all(axiosArr).then((response) => {
        // console.log(response)
        for (let index = 0; index < response.length; index++) {
          const element = response[index]
          // console.log(element)
          if (element.data.code === '0') {
            // 拿到地图
            this.roadList[index].mapPic = element.data.data.mapPic
            // 如果为非手绘地图模式，取消手绘地图
            if (!this.moudleMap) {
              this.roadList[index].mapPic = this.moudleMapData[index].mapPic
            }
            // 如果地图上有marker点位，拿到marker点位的信息
            if (element.data.data.map.marker.length > 0) {
              const markerList = element.data.data.map.marker
              // console.log(markerList, 'markerList')
              for (let j = 0; j < markerList.length; j++) {
                const element = markerList[j]
                // console.log(element)
                let mapMarkerItem = {
                  thumbnail: '',
                  abscissa: element.abscissa,
                  ordinate: element.ordinate,
                  facilityId: element.facilityId,
                  materialId: element.materialId,
                  markerName: element.markerName,
                  entityId: element.entityId,
                  turnLeft:
                    Number(element.abscissa.replace('%', '')) > 88
                      ? true
                      : false,
                  read: false,
                }
                // 如果为非手绘地图模式,更改marker点位置
                if (!this.moudleMap) {
                  mapMarkerItem.abscissa =
                    this.moudleMapData[index].mapMarker[j].abscissa
                  mapMarkerItem.ordinate =
                    this.moudleMapData[index].mapMarker[j].ordinate
                }
                this.roadList[index].mapMarker.push(mapMarkerItem)
              }
            }
          }
        }
      })
    },
    formatArticleList() {
      this.appList.appGroupArray.forEach((appGroupEle, appGroupIdx) => {
        if (appGroupEle.name === '资讯') {
          // console.log(appGroupEle, '资讯')
          let arr = appGroupEle.appEntityArray[0].groupArray[0].materialArray
          arr.forEach((materialEl, materialIndex) => {
            let obj = {
              name: materialEl.name,
              intro: materialEl.intro,
              extUrl: materialEl.extUrl,
              thumbnail: materialEl.thumbnail,
            }
            this.articleList.push(obj)
          })
        }
      })
    },
    formatAroundList() {
      this.appList.appGroupArray.forEach((appGroupEle, appGroupIdx) => {
        if (appGroupEle.name === '周边') {
          // console.log(appGroupEle, '周边')
          let arr = appGroupEle.appEntityArray
          // let arr = appGroupEle.appEntityArray[0].groupArray[0].materialArray
          arr.forEach((appEntityEl, materialIndex) => {
            let obj = {
              id: appEntityEl.id,
              name: appEntityEl.name,
              intro: appEntityEl.intro,
              thumbnail: appEntityEl.thumbnail,
            }
            this.aroundList.push(obj)
          })
        }
      })
    },
    formatVedioList() {
      this.appList.appGroupArray.forEach((appGroupEle, appGroupIdx) => {
        if (appGroupEle.name === '红色印记') {
          console.log(appGroupEle, '红色印记')
          let arr = appGroupEle.appEntityArray[0].groupArray[0].materialArray
          arr.forEach((materialEl, materialIndex) => {
            // console.log(materialEl, 'materialEl')
            let obj = {
              name: materialEl.name,
              videoCoverImgUrl: materialEl.video.videoCoverImgUrl,
              videoIntro: materialEl.video.videoIntro,
            }
            this.videoList.push(obj)
          })
        }
      })
    },
    // 获取喜欢数和浏览数
    getLikeAndVisit() {
      this.$api.getAppZanNum(this.APPID).then((res) => {
        this.visitNum = res.data.data.visitCount
        this.likeNum = res.data.data.thumbUpCount
      })
    },
    // 添加浏览数
    addVisit() {
      this.$api.getVisitCount({ appId: this.APPID })
    },
    // 是否已喜欢
    couldLike() {
      this.$api.getThumbUpStatus({ appId: this.APPID }).then((res) => {
        console.log(res.data.data, 'like----')
        this.isLike = res.data.data
      })
    },
    // 添加喜欢数
    addLike() {
      if (!this.isLike) {
        this.isLike = true
        this.$api.getThumbUpCount({ appId: this.APPID }).then((res) => {
          if (res.data.code === '0') {
            this.likeNum = this.likeNum + 1
          } else {
            this.isLike = false
          }
        })
      }
    },
    darkOn() {
      if (this.hasDark) {
        // this.darkPanoInfo
        window.pano.setPanoId(this.darkPanoInfo.panoId, () => {
          window.pano.clearMarkers()
          window.pano.setHeading(this.darkPanoInfo.heading || 0)
          window.pano.setPitch(this.darkPanoInfo.pitch || 0)
          this.isDark = true
        })
      }
    },
    darkOff() {
      if (this.hasDark) {
        // this.darkPanoInfo
        window.pano.setPanoId(this.curPano.panoInfo.panoId, () => {
          this.addMarker(this.curPano.id, 0)
          window.pano.setHeading(this.curPano.panoInfo.heading || 0)
          window.pano.setPitch(this.curPano.panoInfo.pitch || 0)
          this.isDark = false
        })
      }
    },
    // 播放视频关闭音乐
    videoPaly() {
      this.audioPause()
    },
    // 重置全景宽高，避免横竖屏显示bug
    setPanoRequestLayout() {
      let that = this
      window.addEventListener(
        'resize',
        function () {
          clearTimeout(that.k)
          that.k = setTimeout(() => {
            alert(1)
            window.pano.requestLayout()
          }, 300)
        },
        false
      )
    },
    // 页面全屏
    setPageFullscreen() {
      if (this.isPageFullScreen) {
        this.exitFullscreen()
      } else {
        this.launchFullscreen()
      }
    },
    // 进入全屏逻辑
    launchFullscreen() {
      let el = document.documentElement
      let rfs =
        el.requestFullScreen ||
        el.webkitRequestFullScreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullScreen
      if (rfs) {
        // typeof rfs != "undefined" && rfs
        rfs.call(el)
      } else if (typeof window.ActiveXObject !== 'undefined') {
        // for IE，这里其实就是模拟了按下键盘的F11，使浏览器全屏
        let wscript = new window.ActiveXObject('WScript.Shell')
        if (wscript != null) {
          wscript.SendKeys('{F11}')
        }
      }
      this.isPageFullScreen = true
    },
    // 退出全屏逻辑
    exitFullscreen() {
      let el = document
      let cfs =
        el.cancelFullScreen ||
        el.webkitCancelFullScreen ||
        el.mozCancelFullScreen ||
        el.exitFullScreen
      if (cfs) {
        // typeof cfs != "undefined" && cfs
        cfs.call(el)
      } else if (typeof window.ActiveXObject !== 'undefined') {
        // for IE，这里和fullScreen相同，模拟按下F11键退出全屏
        let wscript = new window.ActiveXObject('WScript.Shell')
        if (wscript != null) {
          wscript.SendKeys('{F11}')
        }
      }
      this.isPageFullScreen = false
    },
    shareClick(index) {
      this.shareSelectedIndex = index

      let img = this.appInfo.logo || this.appInfo.thumbnail
      let title = this.appInfo.shareTitle || ''
      let content = this.appInfo.shareDesc || ''
      if (index === 0) {
        // 微信
      } else if (index === 1) {
        // qq
        window.open(
          'https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=' +
            location.href +
            '&sharesource=qzone&title=' +
            title +
            '&pics=' +
            img +
            '&summary=' +
            content +
            ''
        )
      } else if (index === 2) {
        // 微博
        window.open(
          'http://service.weibo.com/share/share.php?url=http://t.cn/AiW4llWs&shareTitle=' +
            title +
            '&shareDesc=' +
            content +
            '&thumbnail=' +
            img +
            ''
        )
      }
    },
  },
}
</script>
<style lang="scss">
@import '../assets/css/pc.scss';
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.marker {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  p {
    // width: rem(115);
    text-align: center;
    letter-spacing: 1.2px;
    color: #fff;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    margin-bottom: rem(10);
    font-size: rem(20);
    background-color: rgba(0, 0, 0, 0.5);
    padding: rem(5) rem(10);
    border-radius: 10px;
  }
  img {
    width: rem(62);
    height: rem(62);
    border-radius: 50%;
    border: 3px solid rgb(255, 210, 63);
    display: block;
  }
}
.marker--go {
  img {
    width: rem(68);
    height: rem(68);
    border: none;
  }
}
.marker--road {
  background: url('../assets/img/marker-road.png') no-repeat center center/100%
    100%;
  p {
    margin-top: rem(2);
    padding: rem(8) rem(12);
  }
}
.marker--href {
  display: none;
  width: rem(62);
  height: rem(62);
  border-radius: 50%;
  background: url('../assets/img/marker-href.png') no-repeat center center/100%
    100%;
}
.marker--video {
  // width: rem(62);
  // height: rem(62);
  // border-radius: 50%;
  // background: url('../assets/img/marker-video.png') no-repeat center center/100%
  //   100%;
  img {
    width: rem(68);
    height: rem(68);
    border-radius: 50%;
    border: none;
    display: block;
  }
}
.map-marker {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // position: absolute;
  // top: 0;
  // left: 0;
  p {
    // width: rem(115);
    font-size: rem(16);
    text-align: center;
    letter-spacing: 1.2px;
    color: #fff;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    margin-bottom: rem(10);
    display: none;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -100%);
  }
  img {
    width: rem(40);
    height: rem(40);
    border-radius: 50%;
    border: 2px solid #fff;
    display: block;
  }
  &:hover {
    transform: scale(1.1);
    p {
      display: block;
    }
  }
  &.selected {
    transform: scale(1.1);
    p {
      display: block;
    }
  }
}
.amap-marker {
  width: rem(44);
  height: rem(44);
}
.amap-marker-content {
  width: 100%;
  height: 100%;
}
.pc {
  .pc_top {
    width: 100%;
    height: rem(120);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 6;
    background: url('../assets/img/mobile_top-bg.png') no-repeat top left/100%
      100%;
    display: flex;
    align-items: flex-start;
    padding: rem(10) rem(0);
    box-sizing: border-box;
    padding-left: rem(40);
    padding-top: rem(20);
  }
  .pc_top_logo {
    width: rem(248);
    margin-right: rem(20);
    img {
      display: block;
      width: 100%;
    }
  }
  .pc_top_look {
    font-size: rem(16);
    color: #fff;
    display: flex;
    align-items: center;
    margin-left: rem(0);
    margin-top: rem(10);
    position: relative;
    img {
      display: block;
      width: rem(18);
      margin-right: rem(5);
    }
    &::after {
      content: '';
      position: absolute;
      width: 1px;
      height: 10px;
      background: rgba(255, 255, 255, 0.9);
      top: 50%;
      left: rem(-10);
      transform: translateY(-50%);
    }
  }
  .pc_top_zhibo {
    cursor: pointer;
    width: rem(60);
    margin-left: rem(40);
    margin-top: rem(20);
    // height: rem(20);
    img {
      display: block;
      width: 100%;
      // height: 100%;
    }
  }
  .pc_tools {
    position: fixed;
    z-index: 9;
    bottom: rem(120);
    left: 0;
    width: 100%;
    height: rem(100);
    // background: url('../assets/img/pc/bottom-bg.png') no-repeat center
    //   center/100% 100%;

    display: flex;
    align-items: center;
    padding-left: rem(60);
    box-sizing: border-box;
    &.pc_tools--bottom {
      bottom: rem(0);
      background: url('../assets/img/pc/bottom-bg.png') no-repeat center
        center/100% 100%;
    }
  }
  .pc_tools_qrcode {
    position: absolute;
    top: 0;
    left: rem(170);
    transform: translateY(-170%);
    width: rem(140);
    height: rem(140);
    background: rgba($color: #000000, $alpha: 0.2);
    canvas {
      width: rem(120) !important;
      height: rem(120) !important;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
    }
  }
  .pc_tools_share {
    position: absolute;
    left: rem(120);
    top: 0;
    transform: translateY(-90%);
    width: rem(240);
    height: rem(100);
    background: url('../assets/img/pc/share-bg.png') no-repeat center
      center/100% 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .pc_tools_share_item {
    cursor: pointer;
    width: rem(42);
    height: rem(60);
  }
  .pc_tools_share_item--weixin {
    background: url('../assets/img/pc/share_item-weixin.png') no-repeat center
      center/100% 100%;
    &.pc_tools_share_item--weixin--selected {
      background: url('../assets/img/pc/share_item-weixin-true.png') no-repeat
        center center/100% 100%;
    }
  }
  .pc_tools_share_item--qq {
    background: url('../assets/img/pc/share_item-qq.png') no-repeat center
      center/100% 100%;
    &.pc_tools_share_item--qq--selected {
      background: url('../assets/img/pc/share_item-qq-true.png') no-repeat
        center center/100% 100%;
    }
  }
  .pc_tools_share_item--weibo {
    background: url('../assets/img/pc/share_item-weibo.png') no-repeat center
      center/100% 100%;
    &.pc_tools_share_item--weibo--selected {
      background: url('../assets/img/pc/share_item-weibo-true.png') no-repeat
        center center/100% 100%;
    }
  }
  .pc_tools_list {
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    padding: 0 rem(20);
    border: 1px solid rgba(255, 255, 255, 0.589);
    border-radius: 30px;
  }
  .pc_tools_list_item {
    cursor: pointer;
    width: rem(62);
    height: rem(62);
    display: flex;
    // justify-content: center;
    // align-items: center;
    position: relative;
    img {
      display: block;
      width: 60%;
      height: 60%;
      margin: auto;
    }
    &:not(:last-child)::after {
      content: '';
      width: 1px;
      height: 10px;
      background: rgba(255, 255, 255, 0.589);
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .pc_tools_list_item_like {
    font-size: 12px;
    color: #fff;
    position: absolute;
    bottom: rem(-2);
    left: 50%;
    transform: translateX(-50%);
  }
  .pc_tools_dark {
    cursor: pointer;
    width: rem(62);
    height: rem(62);
    display: flex;
    border-radius: 50%;
    border: 1px solid rgba(255, 255, 255, 0.589);
    margin-left: rem(30);
    background: rgba(0, 0, 0, 0.3);
    img {
      display: block;
      width: 60%;
      height: 60%;
      margin: auto;
    }
  }
  .map-box {
    width: rem(158);
    height: rem(158);
    position: absolute;
    left: rem(40);
    top: rem(130);
    z-index: 7;
    transform: translate3d(0, 0, 0);
    transition: transform 0.2s;
    // &.moveIn-enter,
    // &.moveIn-leave-to {
    //   transform: translate3d(rem(82), 0, 0);
    // }
    // &.moveIn-enter-active,
    // &.moveIn-leave-active {
    //   transition: transform 0.2s;
    // }
    // &.haveOtherPano {
    //   transform: translate3d(0, rem(-110), 0);
    //   &.moveIn-enter,
    //   &.moveIn-leave-to {
    //     transform: translate3d(rem(82), rem(-110), 0);
    //   }
    // }
    .back {
      width: rem(158);
      height: rem(158);
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.3);
      opacity: 1;
    }
    .map {
      width: rem(145);
      height: rem(145);
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      border-radius: 50%;
      overflow: hidden;
      .radar {
        width: rem(80);
        height: rem(80);
        position: absolute;
        left: rem(73);
        top: rem(32);
        transform: rotateZ(0);
        transform-origin: left center;
        &::after {
          content: ' ';
          display: block;
          width: rem(80);
          height: rem(80);
          position: absolute;
          left: 0;
          top: 0;
          background: url('../assets/img/map-triangle.png') no-repeat 0 0;
          background-size: 100% 100%;
        }
      }
      .circle {
        width: rem(48);
        height: rem(60);
        position: absolute;
        left: 50%;
        top: 50%;
        background: url('../assets/img/map-circle.png') no-repeat 0 0;
        background-size: 100% 100%;
        transform: translate3d(-50%, -50%, 0);
        z-index: 2;
      }
    }
    .click-cover {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      cursor: pointer;
      z-index: 11;
    }
  }
  #mapContainer {
    width: rem(145);
    height: rem(145);
    position: absolute;
    left: 0;
    top: 0;
    border-radius: 50%;
    overflow: hidden;
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    .amap-logo,
    .amap-copyright {
      display: none !important;
    }
  }
  .mobile_map {
    position: fixed;
    z-index: 999;
    background: #fff;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
  .mobile_map_close {
    width: rem(50);
    height: rem(50);
    position: absolute;
    right: rem(20);
    top: rem(20);
    z-index: 9;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .full-map-box {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    padding: rem(3) 0;
    box-sizing: border-box;
  }
  .mobile_map_list {
    width: 100%;
    height: rem(400);
    overflow-y: scroll;
    background: rgba(0, 0, 0, 0.4);
    position: absolute;
    bottom: 0;
    left: 0;
    transform: translateY(100%);
    transition: all 0.1s;
    -webkit-overflow-scrolling: touch;
  }
  .mobile_map_list--show {
    transform: translateY(0%);
  }
  .mobile_map_list_title {
    padding-top: rem(5);
    color: #fff;
    position: absolute;
    z-index: 9;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.4);
    bottom: rem(0);
    // transform: translateY(-100%);
    width: rem(100);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    transition: all 0.1s;
    img {
      display: block;
      width: rem(20);
      transform: rotate(180deg);
    }
  }
  .mobile_map_list_title--show {
    bottom: rem(400);
    img {
      transform: rotate(0deg);
    }
  }
  .mobile_map_list_item {
    font-size: rem(16);
    padding: rem(8) rem(20);
    box-sizing: border-box;
    color: #fff;
  }
  .mobile_map_list_item--selected {
    background: rgba(131, 129, 129, 0.8);
  }
  #fullMapContainer {
    width: 100vw;
    height: 100vh;
    .amap-logo,
    .amap-copyright {
      display: none !important;
    }
  }
  .pc_back {
    cursor: pointer;
    width: rem(158);
    height: rem(85);
    position: absolute;
    left: rem(40);
    top: rem(40);
    z-index: 9;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  .pc_tab {
    position: absolute;
    z-index: 9;
    width: rem(340);
    height: rem(620);
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    background: url('../assets/img/pc/tab-bg.png') no-repeat center center/100%
      100%;
    padding: rem(80) rem(0);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    transition: 0.2s;
    &.pc_tab--close {
      transform: translate(100%, -50%);
    }
  }
  .pc_tab_link {
    cursor: pointer;
    width: rem(28);
    height: rem(160);
    position: absolute;
    left: 0;
    top: 50%;
    transform: translate(-96%, -50%);
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .pc_tab_item {
    cursor: pointer;
    width: rem(300);
    height: rem(100);
    background: url('../assets/img/pc/tab_item.png') no-repeat center
      center/100% 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 rem(40);
    box-sizing: border-box;
    color: rgba(255, 223, 135, 1);
    font-size: rem(22);
    font-weight: bold;
    &:hover {
      color: #fff;
      background: url('../assets/img/pc/tab_item-hover.png') no-repeat center
        center/110% 128%;
    }
  }
  .pc_tab_item_icon {
    width: rem(56);
    height: rem(56);
    border-radius: 50%;
  }
  .pc_tab_item--yanxue {
    .pc_tab_item_icon {
      background: url('../assets/img/pc/tab_yanxue.png') no-repeat center
        center/100% 100%;
    }
    &:hover {
      .pc_tab_item_icon {
        background: url('../assets/img/pc/tab_yanxue-hover.png') no-repeat
          center center/100% 100%;
      }
    }
  }
  .pc_tab_item--zixun {
    .pc_tab_item_icon {
      background: url('../assets/img/pc/tab_zixun.png') no-repeat center
        center/100% 100%;
    }
    &:hover {
      .pc_tab_item_icon {
        background: url('../assets/img/pc/tab_zixun-hover.png') no-repeat center
          center/100% 100%;
      }
    }
  }
  .pc_tab_item--zhoubian {
    .pc_tab_item_icon {
      background: url('../assets/img/pc/tab_zhoubian.png') no-repeat center
        center/100% 100%;
    }
    &:hover {
      .pc_tab_item_icon {
        background: url('../assets/img/pc/tab_zhoubian-hover.png') no-repeat
          center center/100% 100%;
      }
    }
  }
  .pc_tab_item--yinji {
    .pc_tab_item_icon {
      background: url('../assets/img/pc/tab_yinji.png') no-repeat center
        center/100% 100%;
    }
    &:hover {
      .pc_tab_item_icon {
        background: url('../assets/img/pc/tab_yinji-hover.png') no-repeat center
          center/100% 100%;
      }
    }
  }
  .pc_yanxue {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 99;
    background: rgb(199, 131, 131);
  }
  .pc_yanxue_return {
    cursor: pointer;
    width: rem(158);
    height: rem(85);
    position: absolute;
    left: rem(40);
    top: rem(40);
    z-index: 9;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .pc_yanxue_left {
    width: 82%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 6;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .pc_yanxue_right {
    width: rem(460);
    height: 100%;
    background: url('../assets/img/pc/yanxue_right-bg.png') no-repeat center
      left/110% 109%;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 9;
    // padding-top: rem(350);
    // box-sizing: border-box;
  }
  .pc_yanxue_right_title {
    width: rem(130);
    position: absolute;
    top: rem(40);
    left: rem(220);
    img {
      display: block;
      width: 100%;
    }
  }
  .pc_yanxue_right_detail {
    border: 1px solid rgba(255, 251, 241, 1);
    border-radius: 5px;
    width: rem(380);
    height: rem(180);
    overflow-y: scroll;
    box-sizing: border-box;
    // background: url('../assets/img/pc/yanxue_right_detail-bg.png') no-repeat
    //   center center/100% 100%;
    position: absolute;
    top: rem(350);
    left: rem(63);
    padding: rem(10);
    box-sizing: border-box;
    color: rgba(255, 251, 241, 1);
    font-size: rem(14);
    text-indent: 2em;
    &::-webkit-scrollbar-track {
      // background: red;
    }
    &::-webkit-scrollbar-thumb {
      // background: red;
      background: rgba(255, 251, 241, 0.4);
      border-radius: 5px;
    }
    &::-webkit-scrollbar {
      background-color: rgba(0, 0, 0, 0);
      width: 5px;
      border-radius: 5px;
    }
  }
  .pc_yanxue_right_list {
    width: rem(300);
    position: absolute;
    top: rem(600);
    left: rem(105);
  }
  .pc_yanxue_right_list_item {
    width: 100%;
    height: rem(50);
    line-height: rem(50);
    text-align: center;
    background: linear-gradient(360deg, #e01d43 0%, #ff575e 100%);
    border-radius: 10px;
    font-size: rem(20);
    color: #fffdf7;
    margin-bottom: rem(20);
    &:hover {
      background: linear-gradient(360deg, #f6b647 0%, #ffe194 100%);
    }
  }
  .pc_panolist {
    display: flex;
    align-items: center;
    width: 100%;
    height: rem(130);
    // overflow-x: auto;
    // border-radius: 12px 12px 0px 0px;
    background: url('../assets/img/pc/bottom-bg.png') no-repeat center
      center/100% 100%;
    position: fixed;
    z-index: 9;
    bottom: rem(0);
    left: 0;
    padding: rem(20);
    // padding-top: rem(30);
    box-sizing: border-box;
  }
  .pc_panolist_item {
    cursor: pointer;
    flex-shrink: 0;
    width: rem(90);
    height: rem(90);
    padding: 3px;
    box-sizing: border-box;
    background: #fff;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.3);
    margin-right: rem(30);
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  .pc_panolist_item--selected {
    transform: scale(1.15);
    transition: all 0.1s;
  }
  .pc_panolist_item_cover {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    p {
      width: 100%;
      position: absolute;
      bottom: 3px;
      left: 0;
      color: #fff;
      font-size: rem(10);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-left: rem(8);
      box-sizing: border-box;
    }
  }
  .pc_panodetail {
    width: rem(400);
    height: rem(800);
    background-color: #fff;
    border-radius: 10px;
    position: absolute;
    z-index: 9;
    right: rem(50);
    top: 50%;
    transform: translateY(-50%);
    overflow: hidden;
  }
  .pc_panodetail_pic {
    width: 100%;
    height: rem(300);

    img {
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 10px;
    }
  }
  .pc_panodetail_title {
    font-size: rem(24);
    width: 75%;
    margin: rem(30) auto;
    text-align: center;
    font-weight: bold;
  }
  .pc_panodetail_text {
    text-indent: 2em;
    width: 90%;
    height: rem(320);
    overflow-y: auto;
    margin: 0 auto;
    line-height: rem(30);
    &::-webkit-scrollbar-track {
      // background: red;
    }
    &::-webkit-scrollbar-thumb {
      // background: red;
      background: rgb(151, 149, 144);
      border-radius: 5px;
    }
    &::-webkit-scrollbar {
      background-color: rgba(0, 0, 0, 0);
      width: 5px;
      border-radius: 5px;
    }
  }
  .pc_panodetail_icon {
    cursor: pointer;
    position: absolute;
    top: rem(335);
    right: rem(20);
    display: block;
    width: rem(20);
  }
  .pc_infodetail {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 99;
    background-color: rgba(0, 0, 0, 0.9);
  }
  .pc_infodetail_content {
    width: rem(1440);
    height: rem(840);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: url('../assets/img/pc/roadlist_content-bg.png') no-repeat center
      center/100% 100%;
    display: flex;
  }
  .pc_infodetail_content_close {
    cursor: pointer;
    width: rem(30);
    height: rem(30);
    position: absolute;
    right: rem(30);
    top: rem(30);
    z-index: 9;
    img {
      display: block;
      width: 100%;
    }
  }
  .pc_infodetail_content_left {
    width: 70%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.8) 0%,
      rgba(255, 255, 255, 0.7) 13%,
      rgba(255, 255, 255, 0.6) 32%,
      rgba(255, 255, 255, 0.3) 62%,
      rgba(255, 255, 255, 0.1) 100%
    );
  }
  .pc_infodetail_content_left_swiper {
    width: 80%;
    height: 60%;
    border-radius: 10px;
    .infodetail_swiper-pagination {
      position: absolute;
      z-index: 9;
      bottom: rem(0);
      display: flex;
      height: rem(30);
      justify-content: center;
      align-items: center;
      background: rgba(0, 0, 0, 0.3);
    }
    .swiper-pagination-bullet {
      background: rgb(221, 221, 221);
    }
    .swiper-pagination-bullet-active {
      background: #fff;
    }
  }
  .pc_infodetail_content_left_swiper_slide {
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .pc_infodetail_content_right {
    width: 30%;
    height: 100%;
    padding-top: rem(80);
    box-sizing: border-box;
    position: relative;
  }
  .pc_infodetail_content_right_icon {
    cursor: pointer;
    position: absolute;
    top: rem(107);
    right: rem(30);
    display: block;
    width: rem(20);
  }
  .pc_infodetail_content_right_title {
    font-size: rem(30);
    width: 70%;
    margin: rem(20) auto;
    color: rgba(255, 240, 202, 1);
    text-align: center;
  }
  .pc_infodetail_content_right_text {
    width: 80%;
    margin: 0 auto;
    height: rem(550);
    text-indent: 2em;
    overflow-y: auto;
    line-height: rem(30);
    color: #fff;
    &::-webkit-scrollbar-track {
      // background: red;
    }
    &::-webkit-scrollbar-thumb {
      // background: red;
      background: rgba(0, 0, 0, 0.2);
      border-radius: 5px;
    }
    &::-webkit-scrollbar {
      background-color: rgba(0, 0, 0, 0);
      width: 5px;
      border-radius: 5px;
    }
  }
}
</style>
